/**
 * Simple Buffer polyfill for browser environments
 * This allows Node.js libraries that depend on Buffer to work in the browser
 */

// Only add the polyfill if Buffer is not already defined
if (typeof window !== 'undefined' && typeof window.Buffer === 'undefined') {
  // @ts-ignore
  window.Buffer = {
    from: (data: string, encoding?: string) => {
      if (encoding === 'base64') {
        return Uint8Array.from(atob(data), c => c.charCodeAt(0));
      }
      return new TextEncoder().encode(data);
    },
    isBuffer: (obj: any) => false,
    alloc: (size: number) => new Uint8Array(size),
  };
}

export {};
